export interface __PaginationType<T> {
    num_of_pages: number;
    count: number;
    data: T[];
}

export interface __ResponseType<T> {
    data: T;
    status: number;
}

export enum __CookiesEnum {
    accessToken = 'MRCityAccessToken',
    theme = 'MRCityTheme',
    location = 'MRCityLocation',
}

export enum __BPEnum {
    XS = 391,
    SM = 576,
    MD = 768,
    LG = 992,
    XL = 1200,
    XXL = 1600,
}
export interface __JWTTokenType {
    access: string;
    refresh: string;
    expire_date: string;
}

export enum __ThemeEnum {
    light = 'light',
    dark = 'dark',
}
